import React from 'react';
import { Component } from 'react';

import v4 from '../js/game';

import styles from '../styles/Surface.css';

export default class Game extends Component {

  constructor () {
    super();

    this.hasStarted = false;
    this.hasPlayingStarted = false;
    this.hasCountdownStarted = false;
    this.hasFinishingStarted = false;
  }

  componentDidMount () {
    this.canvas = this.refs.surface;

    console.log("Game mounted");

    v4.setup(this.canvas, null);

    v4.getGame().on("resourcesLoaded", this.props.onResourcesLoaded);
    v4.getGame().on("resourcesProgress", this.props.onResourcesProgress);

    this.doImperitiveStuff();
  }

  componentDidUpdate () {
    this.doImperitiveStuff();
  }

  componentWillUnmount() {
    v4.stop();
  }

  doImperitiveStuff () {
    const { playState, api, score, animation, playerRacer, enemyRacer } = this.props;
    const { questionNumber, correctAnswers } = api;

    if (playState == "countdown") {
      if (!this.hasStarted) {
        v4.setPlayerRacer(playerRacer);
        v4.setEnemyRacer(enemyRacer);
        v4.start();
        this.hasStarted = true;
      }

      if (!this.hasCountdownStarted){
        v4.startCountdown();

        this.hasCountdownStarted = true;
      }
    }
    else if (playState == "playing") {
      if (!this.hasStarted) {
        v4.start();
        this.hasStarted = true;
      }

      if (!this.hasPlayingStarted){
        v4.startMoving();
        v4.movePlayerToStep(0);
        v4.moveEnemyToStep(0);

        this.hasPlayingStarted = true;
      } else {
        const enemySteps = questionNumber - correctAnswers * 2;
        v4.moveEnemyToStep(enemySteps);
      }
    }
    else if (playState == "finishing") {
      if(!this.hasFinishingStarted) {
        v4.finishRace();
        this.hasFinishingStarted = true;
      }
    }
    else if (playState == "stopped"){
      v4.stop();
      v4.setup(this.canvas, null);
      this.hasStarted = false;
      this.hasPlayingStarted = false;
      this.hasCountdownStarted = false;
      this.hasFinishingStarted = false;
    }

    if(animation == "player-correct") {
      v4.setPlayerFlame(true);
    }
    else {
      v4.setPlayerFlame(false);
    }

    if(animation == "enemy-correct") {
      v4.setEnemyFlame(true);
    }
    else {
      v4.setEnemyFlame(false);
    }
  }

  render () {
    return (
      <canvas ref="surface" className={styles.surface}></canvas>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Game.js